import { Component, inject, OnInit }            from '@angular/core';
import { UntypedFormBuilder }                   from '@angular/forms';
import { ActivatedRoute, Router }               from '@angular/router';
import { MatIcon }                              from '@angular/material/icon';
import { MatProgressSpinner }                   from '@angular/material/progress-spinner';

import { UserService }                from '../../../../api/user/user.service';
import { DcpInternalErrorCode }       from '../../../../core/error-handling/dcp-error-model';
import { PinNotificationComponent }   from '../../../../shared/components/notification/notification.component';
import { ButtonComponent }            from '../../../../shared/components/buttons/button.component';
import { AgentRegistrationComponent } from '../../../public/registration/agent-registration/agent-registration.component';

enum InvitationNotification {
  SelfRegistrationAccess,
  AgentAccountAccessNotAllowed,
  InvitationDataInvalid,
  InvitationExpired
}

@Component({
  selector: 'pin-login-page',
  templateUrl: './pre-invitation-registration.component.html',
  imports: [PinNotificationComponent, MatIcon, ButtonComponent, AgentRegistrationComponent, MatProgressSpinner]
})

export class PreInvitationRegistrationComponent implements OnInit {
  isLoading = false;
  notificationValue = InvitationNotification;
  notification: InvitationNotification;
  invitationId: string;
  email: string;
  private route = inject(ActivatedRoute);
  private formBuilder = inject(UntypedFormBuilder);
  private router = inject(Router);
  private userService = inject(UserService);

  ngOnInit() {
    this.isLoading = true;
    const queryParams = this.route.snapshot.queryParamMap;
    this.invitationId = queryParams.get('id');
    this.email = queryParams.get('email');
    this.userService.checkAgentInvitation(this.invitationId, this.email).subscribe({
      next: () => {
        this.isLoading = false;
        this.notification = InvitationNotification.SelfRegistrationAccess;
      },
      error: (error) => {
        this.isLoading = false;
        this.handleError(error.error);
      }
    });
  }

  handleError(error: Error) {
    switch (error.message) {
      case DcpInternalErrorCode.ERR_ACCESS_NOT_ALLOWED:
        this.notification = this.notificationValue.AgentAccountAccessNotAllowed;
        break;
      case DcpInternalErrorCode.ERR_EXPIRED_INVITATION:
      case DcpInternalErrorCode.ERR_AGENT_ALREADY_REGISTERED:
        this.notification = this.notificationValue.InvitationExpired;
        break;
      case DcpInternalErrorCode.ERR_UNEXPECTED:
        this.notification = this.notificationValue.InvitationDataInvalid;
        break;
      case DcpInternalErrorCode.ERR_REGISTRATION_NOT_CONFIRMED:
        this.router.navigate(['/login']);
        break;
      default:
        throw error;
    }
  }
}
